import { useReviews } from '../api/getReviews';
import { Spinner } from 'components/Elements';
import { Star } from 'react-feather';

export const Reviews = () => {
  const { data, isLoading } = useReviews();

  if (isLoading) {
    return (
      <section className="py-20 text-center">
        <Spinner size="lg" />
      </section>
    );
  }

  const reviews = data?.data?.filter((review) => review.isApproved)?.slice(0, 6) || [];

  if (reviews.length === 0) return null;

  return (
    <section className="py-20 bg-gray-50">
      <div className="px-6 sm:px-12 lg:px-48">
        {/* Header */}
        <div className="text-start mb-12">
          <h2 className="text-2xl sm:text-5xl font-semibold text-[#F8AF10] just-me-again-down-here-regular mb-4">
            What Our Customers Say
          </h2>
          <p className="text-sm sm:text-base text-gray-800 mb-8 leading-relaxed max-w-2xl">
            Real feedback from customers who have experienced our craftsmanship and service.
          </p>
        </div>

        {/* Reviews */}
        <div className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory">
          {reviews.map((review) => (
            <div
              key={review._id}
              className="min-w-[300px] max-w-sm bg-white rounded-2xl shadow-md p-6 snap-start"
            >
              {/* Rating */}
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star
                    key={n}
                    size={16}
                    className={
                      n <= review.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'
                    }
                  />
                ))}
              </div>

              {/* Comment */}
              <p className="text-gray-700 text-sm leading-relaxed line-clamp-4">
                “{review.comment}”
              </p>

              {/* User */}
              <div className="mt-4 text-sm font-medium text-gray-900">
                {review.user?.name || 'Verified Customer'}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
